import {createAsyncThunk} from "@reduxjs/toolkit";
import {executePromise} from "../util/sliceUtil";
import {OrganShareAllocateDTO, OrganShareDeallocateDTO, OrganShareSearchCondition} from "../types/organShare";
import {OrganShareApi} from "../api/OrganShareApi";
import {PageSearchCondition} from "../types/page";

export const getOrganShareListAsync =
    createAsyncThunk("organShare/getOrganShareList", (dto: OrganShareSearchCondition) =>
        executePromise(OrganShareApi.getOrganShareList(dto))
    );

export const getSharedOrganListAsync =
    createAsyncThunk("organShare/getSharedOrganList", (dto: PageSearchCondition) =>
        executePromise(OrganShareApi.getSharedOrganList(dto))
    );

export const getOrganManagerShareListAsync =
    createAsyncThunk("organShare/getOrganManagerShareList", (dto: OrganShareSearchCondition) =>
        executePromise(OrganShareApi.getOrganManagerShareList(dto))
    );

export const allocateAuthorityAsync =
    createAsyncThunk("organShare/allocateAuthority", (dto: OrganShareAllocateDTO) =>
        executePromise(OrganShareApi.allocateAuthority(dto))
    );

export const deallocateAuthorityAsync =
    createAsyncThunk("organShare/deallocateAuthority", (dto: OrganShareDeallocateDTO) =>
        executePromise(OrganShareApi.deallocateAuthority(dto))
    );